import React from "react";

const ShareIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72667 9.00634L9.28 11.6597M9.27333 4.33967L4.72667 6.99301M13 3.33301C13 4.43758 12.1046 5.33301 11 5.33301C9.89543 5.33301 9 4.43758 9 3.33301C9 2.22844 9.89543 1.33301 11 1.33301C12.1046 1.33301 13 2.22844 13 3.33301ZM5 7.99967C5 9.10424 4.10457 9.99967 3 9.99967C1.89543 9.99967 1 9.10424 1 7.99967C1 6.8951 1.89543 5.99967 3 5.99967C4.10457 5.99967 5 6.8951 5 7.99967ZM13 12.6663C13 13.7709 12.1046 14.6663 11 14.6663C9.89543 14.6663 9 13.7709 9 12.6663C9 11.5618 9.89543 10.6663 11 10.6663C12.1046 10.6663 13 11.5618 13 12.6663Z"
      stroke="#2C2C2C"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShareButton = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="border border-[#E6E6E6] rounded-lg px-4 py-2 flex items-center gap-2 hover:bg-gray-50 transition-colors"
      aria-label="Share player profile"
    >
      <ShareIcon />
      <span className="text-[#1E1E1E]">Share</span>
    </button>
  );
};

export default ShareButton;
